var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Monitor","titleIcon":"fas fa-user-check"}},[_c('form-monitor',{attrs:{"paramId":_vm.id},on:{"onSubmitMonitor":_vm.afterSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }